import { colorStrings, mediaQueriesBP } from "@iewc/Utilities/variables";
import { categoryImageStyles as styles } from "@insite/content-library/Widgets/Category/CategoryImage";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.image = {
    ...styles.image,
    css: css`
        display: none;
        img {
            border: 1px solid ${getColor(colorStrings.commonBorder)};
        }
        ${mediaQueriesBP.minMD} {
            display: block;
        }
    `,
};
